import React, { useContext, useState } from 'react';

import { ArrowAngleRight, ArrowAngleLeft } from '@zooplus/icons';

import CartEventsContext from '../../../common/contexts/CartEventsContext';
import FeaturesContext from '../../../common/contexts/FeaturesContext';
import LocResourcesContext from '../../../common/contexts/LocResourcesContext';

import ArticleHighlighted from './ArticleHighlighted';

interface ArticlesHighlightedCarouselProps {
  view: string;
}

const ArticlesHighlightedCarousel = ({
  view
}: ArticlesHighlightedCarouselProps) => {
  const GLOBAL_PREFIX = 'loy-bp-rws-articles-highlighted';
  const ARTICLES_PER_PAGE = 2;
  const card_articles = React.createRef();
  const { articlesHighlighted } = useContext(CartEventsContext);
  const { onFormatLocale } = useContext(LocResourcesContext);
  const { features } = useContext(FeaturesContext);

  const [currentPage, setCurrentPage] = useState<number>(1);

  const previousItems = () => {
    if (currentPage > 1) {
      // @ts-ignore
      card_articles.current.style.transform = `translate(-${580 * (currentPage - ARTICLES_PER_PAGE)}px)`;
      setCurrentPage(currentPage - 1);
    }
  };

  const nextItems = () => {
    // @ts-ignore
    if (currentPage < Math.ceil(card_articles.current.children.length / ARTICLES_PER_PAGE)) {
      // @ts-ignore
      card_articles.current.style.transform = `translate(-${580 * currentPage}px)`;
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    articlesHighlighted &&
    articlesHighlighted.length > 0 &&
    features.articlesHighlighted && (
      <React.Fragment>
        <div className={`${GLOBAL_PREFIX}__carousel`}>
          <div
            className={`${GLOBAL_PREFIX}__carousel__text`}>
            <div className={`${GLOBAL_PREFIX}__title`}>
              {onFormatLocale?.('loy.rewards.shop.promotions.title')}
            </div>
            <div className={`${GLOBAL_PREFIX}__subtitle`}>
              {onFormatLocale?.('loy.rewards.shop.promotions.subtitle')}
            </div>
          </div>

          <div
            className={`${GLOBAL_PREFIX}__carousel__button ${GLOBAL_PREFIX}__carousel__button--previous`}
            onClick={() => previousItems()}>
            <a className={`${currentPage === 1 ? `disabled` : `enabled`}`}>
              <ArrowAngleLeft />
            </a>
          </div>

          <div
            className={`${GLOBAL_PREFIX}__carousel__button ${GLOBAL_PREFIX}__carousel__button--next`}
            onClick={() => nextItems()}>
            <a
              className={`${currentPage === Math.ceil(articlesHighlighted.length / ARTICLES_PER_PAGE) ? `disabled` : `enabled`}`}>
              <ArrowAngleRight />
            </a>
          </div>

          <div className={`${GLOBAL_PREFIX}`}>
            <ul // @ts-ignore
              ref={card_articles}
              className={`${GLOBAL_PREFIX}__articles`}>
              {articlesHighlighted.map((article) => {
                return (
                  <ArticleHighlighted
                    article={article}
                    view={view}
                    key={article.articleId}
                  />
                );
              })}
            </ul>
          </div>
        </div>
      </React.Fragment>
    )
  );
};

export default ArticlesHighlightedCarousel;
